import { Construction } from 'lucide-react';
import { useParams } from 'react-router-dom';

import Page from '@/components/layout/Page';
import HorizontalLogo from '@/components/common/HorizontalLogo';
import {
  Empty,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription
} from '@/components/ui/empty';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { useCoach } from '@/data/coach';
import PageLoading from '@/components/layout/PageLoading';

const TipPage = () => {
  const params = useParams();
  const coach = useCoach(params.coachId);

  if (coach.isLoading && !coach.data) {
    return <PageLoading />;
  }

  return (
    <Page>
      <div className="p-8">
        <HorizontalLogo />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>
            Tip {coach.data.user.firstname} {coach.data.user.lastname}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Empty>
            <EmptyIcon>
              <Construction />
            </EmptyIcon>
            <EmptyTitle>Tip Page Under Construction</EmptyTitle>
            <EmptyDescription>This page is not finished yet</EmptyDescription>
          </Empty>
        </CardContent>
      </Card>
    </Page>
  );
};

export default TipPage;
